export default {
      id: "format-italic-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#format-italic-usage",
      toString: function () {
        return this.url;
      }
    }